var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHostingMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 661.187,
    viewBox: "0 0 800 661.187",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-604 -249.388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M926.654,741.64H128.347c-.468,0-.847-.5-.847-1.126s.379-1.126.847-1.126H926.654c.467,0,.847.5.847,1.126S927.121,741.64,926.654,741.64Z",
    transform: "translate(476.5 163.634)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.753,0,28.6,6.653,21.925,30.746l-30.4-5.01Z",
    transform: "translate(874.453 318.765)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.736,
    height: 22.812,
    transform: "matrix(0.799, 0.602, -0.602, 0.799, 749.023, 829.795)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.656,38.742H60.149A27.968,27.968,0,0,0,72.193,36l8.94-4.3a5.369,5.369,0,0,0-.894-10.013L61.8,16.584,30.245,0l-.024.12c-.59,2.988-1.5,7.5-1.618,7.777-3.235,3.707-6.559,5.415-9.879,5.078-5.79-.587-9.64-7.274-9.678-7.341l-.029-.052-.059.006A3.84,3.84,0,0,0,5.977,7.213c-1.321,1.992-.516,5.059-.383,5.522C4.012,14.283,3.3,22.927,3.247,23.628.96,26.052-.127,28.383.012,30.556A7.461,7.461,0,0,0,3.14,35.8a13.543,13.543,0,0,0,8.512,2.948Z",
    transform: "matrix(0.799, 0.602, -0.602, 0.799, 739.921, 828.973)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.73,
    height: 23.856,
    transform: "translate(892.391 859.714)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.137,620.461h50.712a29.248,29.248,0,0,0,12.6-2.87l9.349-4.493a5.614,5.614,0,0,0-.935-10.471l-19.286-5.337-33-17.343-.025.125c-.617,3.125-1.573,7.846-1.692,8.133-3.384,3.877-6.86,5.663-10.331,5.31-6.055-.614-10.081-7.606-10.121-7.677l-.03-.054-.062.007a4.016,4.016,0,0,0-3.117,1.7c-1.382,2.083-.539,5.291-.4,5.775-1.655,1.618-2.4,10.658-2.454,11.391-2.392,2.535-3.529,4.973-3.384,7.245a7.8,7.8,0,0,0,3.271,5.482,14.163,14.163,0,0,0,8.9,3.082Z",
    transform: "translate(482.326 284.81)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.977,526.726H595.338a8.975,8.975,0,0,1-8.965-8.965V417.353a8.975,8.975,0,0,1,8.965-8.965H892.977a8.975,8.975,0,0,1,8.965,8.965V517.761a8.975,8.975,0,0,1-8.965,8.965Z",
    transform: "translate(390.255 121.383)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.892,
    height: 8.965,
    transform: "translate(1023.247 556.665)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.379,
    cy: 5.379,
    r: 5.379,
    transform: "translate(1200.754 556.665)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.379,
    cy: 5.379,
    r: 5.379,
    transform: "translate(1218.684 556.665)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.379,
    cy: 5.379,
    r: 5.379,
    transform: "translate(1236.613 556.665)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.977,639.78H595.338a8.976,8.976,0,0,1-8.965-8.965V530.407a8.975,8.975,0,0,1,8.965-8.965H892.977a8.975,8.975,0,0,1,8.965,8.965V630.815a8.975,8.975,0,0,1-8.965,8.965Z",
    transform: "translate(390.255 135.632)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.892,
    height: 8.965,
    transform: "translate(1023.247 683.969)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.379,
    cy: 5.379,
    r: 5.379,
    transform: "translate(1200.754 683.969)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.379,
    cy: 5.379,
    r: 5.379,
    transform: "translate(1218.684 683.969)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.379,
    cy: 5.379,
    r: 5.379,
    transform: "translate(1236.613 683.969)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.977,752.835H595.338a8.976,8.976,0,0,1-8.965-8.965V643.461a8.975,8.975,0,0,1,8.965-8.965H892.977a8.975,8.975,0,0,1,8.965,8.965V743.87A8.975,8.975,0,0,1,892.977,752.835Z",
    transform: "translate(390.255 149.881)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.892,
    height: 8.965,
    transform: "translate(1023.247 811.273)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.379,
    cy: 5.379,
    r: 5.379,
    transform: "translate(1200.754 811.273)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.379,
    cy: 5.379,
    r: 5.379,
    transform: "translate(1218.684 811.273)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.379,
    cy: 5.379,
    r: 5.379,
    transform: "translate(1236.613 811.273)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.9,321.431l-.329-.243-.008-.006a4.027,4.027,0,0,0-5.634.832l-66.995,90.2h-7.371v-1.732a1.611,1.611,0,0,0-1.611-1.611h-4.4a1.611,1.611,0,0,0-1.611,1.611v1.732H689.4v-1.732a1.611,1.611,0,0,0-1.611-1.611h-4.4a1.611,1.611,0,0,0-1.611,1.611v1.732h-2.537v-1.732a1.611,1.611,0,0,0-1.611-1.611h-4.4a1.611,1.611,0,0,0-1.611,1.611v1.732h-2.545v-1.732a1.611,1.611,0,0,0-1.611-1.611h-4.4a1.611,1.611,0,0,0-1.611,1.611v1.732h-2.537v-1.732a1.611,1.611,0,0,0-1.611-1.611h-4.4a1.611,1.611,0,0,0-1.611,1.611v1.732h-2.545v-1.732a1.611,1.611,0,0,0-1.611-1.611h-4.4a1.611,1.611,0,0,0-1.611,1.611v1.732h-2.545v-1.732a1.611,1.611,0,0,0-1.611-1.611h-4.4a1.611,1.611,0,0,0-1.611,1.611v1.732h-2.537v-1.732a1.611,1.611,0,0,0-1.611-1.611h-4.4a1.611,1.611,0,0,0-1.611,1.611v1.732h-2.545v-1.732a1.611,1.611,0,0,0-1.611-1.611h-4.4a1.611,1.611,0,0,0-1.611,1.611v1.732h-2.537v-1.732a1.611,1.611,0,0,0-1.611-1.611h-4.4a1.611,1.611,0,0,0-1.611,1.611v1.732h-3.189a4.027,4.027,0,0,0-4.027,4.027v3.842a4.027,4.027,0,0,0,4.027,4.027H706.266a6,6,0,0,0,5.875-4.782l.042.03,68.543-92.287.006-.008a4.028,4.028,0,0,0-.832-5.634Z",
    transform: "translate(391.126 110.292)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.982,301.438s-10.181-7.8-10.181,11.252l-1.607,62.96,17.95,59.477,10.449-19.29-4.287-41.795Z",
    transform: "translate(361.284 107.704)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.211,456.635s11.806,57.493-3.148,104.676L565,736.947l-30.5,3.415L523.873,605.779l-10.232-66.9-21.25,61L422.345,728.95l-32.269-25.185s35.759-97.57,62.176-118.056l13.249-150.9Z",
    transform: "translate(353.959 124.713)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.55,
    cy: 34.55,
    r: 34.55,
    transform: "translate(847.365 312.596) rotate(-61.337)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.161,215.178c4.142.539,7.266-3.7,8.715-7.616s2.553-8.477,6.154-10.593c4.92-2.891,11.214.586,16.84-.368,6.353-1.077,10.484-7.81,10.808-14.246s-2.237-12.626-4.75-18.559l-.877,7.374a14.624,14.624,0,0,0-6.39-12.782l1.131,10.821a11.485,11.485,0,0,0-13.212-9.5l.178,6.447c-7.338-.873-14.74-1.746-22.1-1.082s-14.771,2.993-20.349,7.84c-8.344,7.25-11.391,19.189-10.368,30.2s5.566,21.346,10.3,31.334c1.191,2.513,2.839,5.349,5.6,5.669,2.482.288,4.754-1.787,5.525-4.164a15.092,15.092,0,0,0-.067-7.415c-.7-3.71-1.578-7.5-.922-11.219s3.331-7.391,7.078-7.847,7.582,3.828,5.78,7.145Z",
    transform: "translate(366.648 91)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.685,314.316l-115.328-7.441,8.681-35.962,105.406,23.562Z",
    transform: "translate(489.624 282.406)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.951,245.282l7.234-10.043s8.085,2.748,29.738,13.526l1.53,9.409,37.586,231.177L508.721,486.4l-18.6-.4-6.088-13.648-7.508,13.358-18.168-.387-18.486-10.717,18.218-55.726,5.894-50.9L454.87,320.03s-11.462-44.038,32.686-67.782Z",
    transform: "translate(360.235 99.56)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.043,403.594A11.808,11.808,0,0,1,622.358,393l-40.532-10.857,16.305-14.478,35.99,12.529a11.872,11.872,0,0,1,2.922,23.4Z",
    transform: "translate(389.682 116.251)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.867,410.23a6.916,6.916,0,0,1-5.615.446l-66.676-25.306a71.2,71.2,0,0,1-38.321-32.3l-27.805-49.6a22.256,22.256,0,0,1,33.208-29.641l48.126,76.28,60.566,35.509a6.931,6.931,0,0,1,2.947,7.371l-3.012,12.763a6.917,6.917,0,0,1-2.1,3.547,6.845,6.845,0,0,1-1.316.932Z",
    transform: "translate(366.15 103.486)",
    fill: "#6c63ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostingMaintenance);
export default __webpack_public_path__ + "static/media/hosting-maintenance.ad57d417d078ed1ca1e08c2025ee0c10.svg";
export { ForwardRef as ReactComponent };